import { Injectable } from '@angular/core';
import { BaseWorkflowStateService } from '../base-workflow-state.service';
import { CustomerAccountSetupData } from '../../../../../../models/order/workflow/cutomer-account-setup.model';


@Injectable({ providedIn: 'root' })
export class CustomerAccountSetupStateService extends BaseWorkflowStateService<CustomerAccountSetupData> {
    override stateKey: string = 'customerAccountSetup';
}